'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { ArrowDownCircleS } from '@lichtblick/photon/icons/arrows/arrow-down-circle-s';
import { ArrowDownCircleXs } from '@lichtblick/photon/icons/arrows/arrow-down-circle-xs';
import { DocumentS } from '@lichtblick/photon/icons/objects/document-s';
import { DocumentXs } from '@lichtblick/photon/icons/objects/document-xs';
import { InfoS } from '@lichtblick/photon/icons/symbols/info-s';
import { InfoXs } from '@lichtblick/photon/icons/symbols/info-xs';
import { PhoneS } from '@lichtblick/photon/icons/technology/phone-s';
import { PhoneXs } from '@lichtblick/photon/icons/technology/phone-xs';
import { useTracker } from '@lichtblick/tracker';
import { useCallback, useMemo, useState } from 'react';
import { OInfoDialog } from '../OInfoDialog/OInfoDialog';
export const AButton = ({ className, hasNoIcon, isDownloadLink, isSlim, isWide, linkAsset, linkDialog, linkEntry, linkUrl, openAsPhoneLink: isPhoneLink, openInNewTab: shouldOpenInNewTab, tabIndex, text, trackingOption, variant })=>{
    let button;
    const { trackCustomEvent } = useTracker();
    const hasInfoDialog = linkDialog?.length === 1;
    const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
    const target = shouldOpenInNewTab || Boolean(linkAsset?.filename) ? '_blank' : undefined;
    const href = !linkAsset?.filename ? linkEntry?.cached_url ? `/${linkEntry?.cached_url}${linkUrl ? linkUrl : ''}` : linkUrl : linkAsset.filename;
    const icon = useMemo(()=>{
        if (hasNoIcon) {
            return;
        }
        if (hasInfoDialog) {
            return isSlim ? /*#__PURE__*/ _jsx(InfoXs, {}) : /*#__PURE__*/ _jsx(InfoS, {});
        } else if (isPhoneLink) {
            return isSlim ? /*#__PURE__*/ _jsx(PhoneXs, {}) : /*#__PURE__*/ _jsx(PhoneS, {});
        } else if (isDownloadLink && shouldOpenInNewTab) {
            return isSlim ? /*#__PURE__*/ _jsx(DocumentXs, {}) : /*#__PURE__*/ _jsx(DocumentS, {});
        } else if (isDownloadLink) {
            return isSlim ? /*#__PURE__*/ _jsx(ArrowDownCircleXs, {}) : /*#__PURE__*/ _jsx(ArrowDownCircleS, {});
        }
    }, [
        hasInfoDialog,
        hasNoIcon,
        isDownloadLink,
        isPhoneLink,
        isSlim,
        shouldOpenInNewTab
    ]);
    const handleEvent = useCallback(()=>{
        if (hasInfoDialog) {
            setIsInfoDialogOpen(true);
        }
        if (trackingOption?.[0]?.eventName) {
            trackCustomEvent({
                eventName: trackingOption[0].eventName,
                customProps: trackingOption[0].customProps && JSON.parse(trackingOption[0].customProps)
            });
        }
    }, [
        hasInfoDialog,
        trackCustomEvent,
        trackingOption
    ]);
    if (variant === 'link' || isPhoneLink || isDownloadLink) {
        button = href && !hasInfoDialog ? /*#__PURE__*/ _jsx(TextCTA, {
            as: "a",
            className: className,
            download: !!isDownloadLink,
            href: href,
            icon: icon,
            onClick: handleEvent,
            slim: isSlim,
            tabIndex: tabIndex,
            target: target,
            children: text
        }) : /*#__PURE__*/ _jsx(TextCTA, {
            as: "button",
            className: className,
            icon: icon,
            onClick: handleEvent,
            slim: isSlim,
            tabIndex: tabIndex,
            children: text
        });
    } else {
        const size = isSlim ? 'small' : undefined;
        button = href && !hasInfoDialog ? /*#__PURE__*/ _jsx(BoxCTA, {
            as: "a",
            className: className,
            download: !!isDownloadLink,
            href: href,
            leftSlot: icon,
            onClick: handleEvent,
            size: size,
            tabIndex: tabIndex,
            target: target,
            variant: variant,
            wide: isWide,
            children: text
        }) : /*#__PURE__*/ _jsx(BoxCTA, {
            as: "button",
            className: className,
            leftSlot: icon,
            onClick: handleEvent,
            size: size,
            tabIndex: tabIndex,
            variant: variant,
            wide: isWide,
            children: text
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            button,
            hasInfoDialog && /*#__PURE__*/ _jsx(OInfoDialog, {
                ...linkDialog[0],
                onSecondaryButtonClick: ()=>setIsInfoDialogOpen(false),
                open: isInfoDialogOpen
            })
        ]
    });
};

//# sourceMappingURL=AButton.js.map